import { hasIOSupport } from '../helpers/feature-detects';

function fireSticky(stuck, target) {
	const evt = new CustomEvent('sticky-change', { detail: { stuck, target } });
	document.dispatchEvent(evt);
}

function addSentinels(container, className) {
	return Array.from(container.querySelectorAll('.sticky-header')).map(
		(el) => {
			const sentinel = document.createElement('div');
			sentinel.classList.add('sticky_sentinel', className);
			return el.parentElement.appendChild(sentinel);
		}
	);
}

function observeHeaders(container) {
	const shObserver = new IntersectionObserver(
		(records) => {
			records.forEach((record) => {
				const { boundingClientRect, target, rootBounds } = record;
				const stickyTarget = target.parentElement.querySelector(
					'.sticky-header'
				);

				if (boundingClientRect.bottom < rootBounds.top) {
					fireSticky(true, stickyTarget);
				}

				if (
					boundingClientRect.bottom >= rootBounds.top &&
					boundingClientRect.bottom < rootBounds.bottom
				) {
					fireSticky(false, stickyTarget);
				}
			});
		},
		{
			threshold: [ 0, 1 ],
			// root: container,
		}
	);

	const sentinels = addSentinels(container, 'sticky_sentinel--top');
	sentinels.forEach((el) => shObserver.observe(el));
}

if (hasIOSupport) {
	observeHeaders(document.querySelector('body'));

	document.addEventListener('sticky-change', (e) => {
		const { target, stuck } = e.detail;
		target.classList.toggle('is-stuck', stuck);
		document.documentElement.classList.toggle('header-stuck', stuck);
	});
}
